import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./navbar.css";

const navLinks = [
  { id: "01", title: "Home", target: "header" },
  { id: "02", title: "About", target: "about" },
  { id: "03", title: "Skills", target: "skills" },
  { id: "04", title: "Projects", target: "work" },
  { id: "05", title: "Contact", target: "contact" }
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("header");
  const [introDone, setIntroDone] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 3;
      let currentSection = "";
      
      navLinks.forEach((link) => {
        const el = document.getElementById(link.target);
        if (el) {
          const top = el.offsetTop;
          const height = el.offsetHeight;
          if (scrollPos >= top && scrollPos < top + height) {
            currentSection = link.target;
          }
        }
      });
      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Init
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      setIntroDone(true);
    }, 2800);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  // Prevent scrolling when menu is open
  useEffect(() => {
    if (!introDone) return;
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen, introDone]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavigation = (e, targetId) => {
    e.preventDefault();
    setMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    } else {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <motion.nav 
        className={`navbar ${menuOpen ? "menu-open" : ""}`}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: introDone ? 1 : 0, y: introDone ? 0 : -20 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="nav__name" style={{ zIndex: 1100, position: "relative" }}>
          <span onClick={(e) => handleNavigation(e, "header")} style={{cursor: "pointer"}}>Zii.</span>
        </div>
        
        <div className="nav__desktop-links">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.target}`}
              onClick={(e) => handleNavigation(e, link.target)}
              className={`nav__desktop-link ${activeSection === link.target ? "active" : ""}`}
            >
              {link.title}
            </a>
          ))}
        </div>

        <div className="hamburger-menu" onClick={toggleMenu} style={{ zIndex: 1100, position: "relative" }}>
          <div className={`hamburger ${menuOpen ? "open" : ""}`}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </motion.nav>

      <AnimatePresence>
        {menuOpen && (
          <motion.div 
            className="nav__overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { delay: 0.4, duration: 0.4 } }}
          >
            <div className="nav__overlay-content">
              <div className="nav__overlay-left">
                <span className="nav__bg-text">NAVIGATION</span>
              </div>
              <div className="nav__overlay-right">
                <div className="nav__menu-items">
                  {navLinks.map((link, i) => (
                    <motion.a
                      key={link.id}
                      href={`#${link.target}`}
                      onClick={(e) => handleNavigation(e, link.target)}
                      className="nav__menu-link"
                      initial={{ opacity: 0, x: 40 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: 40 }}
                      transition={{ delay: 0.1 * i, ease: "easeOut", duration: 0.4 }}
                    >
                      <span className="nav__menu-num">{link.id}</span>
                      <span className="nav__menu-title">
                        {link.title}
                        <span className="nav__menu-line"></span>
                      </span>
                    </motion.a>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;